import React from 'react'

export const ContentLayout = ({ children }) => {
  return (
    <div className=' flex justify-items-center  h-full justify-center w-full'>
      <div className='m-auto'>{children}</div>
    </div>
  )
}
